var GoeHistoryChecklistComponent = (function () {
    function GoeHistoryChecklistComponent() {
        this.templateUrl = 'goe-history-checklist.html';
        this.controllerAs = 'vm';
        this.controller = GoeHistoryChecklistController;
    }
    return GoeHistoryChecklistComponent;
}());

//# sourceMappingURL=goeHistoryChecklistComponent.js.map
